import api from './api'
import type { Campaign, CampaignListItem, PaginatedResponse } from '@/types'
import type { CreateCampaignRequest, UpdateCampaignRequest } from '@/types/api'

export const campaignService = {
  async getAll(status?: string, page = 1, pageSize = 50): Promise<PaginatedResponse<CampaignListItem>> {
    const params: Record<string, string | number> = { page, pageSize }
    if (status) params.status = status
    const { data } = await api.get('/manage/campaigns', { params })
    return data
  },

  async getById(id: string): Promise<Campaign> {
    const { data } = await api.get(`/manage/campaigns/${id}`)
    return data
  },

  async create(request: CreateCampaignRequest): Promise<Campaign> {
    const { data } = await api.post('/manage/campaigns', request)
    return data
  },

  async update(id: string, request: UpdateCampaignRequest): Promise<Campaign> {
    const { data } = await api.put(`/manage/campaigns/${id}`, request)
    return data
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/manage/campaigns/${id}`)
  },

  async archive(id: string): Promise<Campaign> {
    const { data } = await api.post(`/manage/campaigns/${id}/archive`)
    return data
  },

  async unarchive(id: string): Promise<Campaign> {
    const { data } = await api.post(`/manage/campaigns/${id}/unarchive`)
    return data
  },
}
